import { PREFIX_PRODUCER } from "@/api/Model/ProductOwnerModel";
import AbstractStandardClause from "../StandardClause";

class StandardClause extends AbstractStandardClause {
  static getResourceEndpoint() {
    return PREFIX_PRODUCER + '/product-standard-clauses-ipr';
  }
}

export default StandardClause;
